import { render, staticRenderFns } from "./ReportDownPayment.vue?vue&type=template&id=184579d6&scoped=true"
import script from "./ReportDownPayment.vue?vue&type=script&lang=js"
export * from "./ReportDownPayment.vue?vue&type=script&lang=js"
import style0 from "./ReportDownPayment.vue?vue&type=style&index=0&id=184579d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184579d6",
  null
  
)

export default component.exports